<script lang="ts">
	import Label from "#lib/components/Label.svelte";
	import ColorInputV2 from "#lib/components/flow/editor/appearance/ColorInputV2.svelte";
	import { camelCase } from "#lib/string.js";
	import type { JsonValue } from "@bufbuild/protobuf";

	interface Props {
		prefix?: string;
		defaults?: Record<string, JsonValue>;
		values: Record<string, JsonValue>;
		onInput?: (key: string, value: JsonValue) => void;
		onChange?: (key: string, value: JsonValue) => void;
	}

	let { prefix = "", defaults = {}, values, onInput, onChange }: Props = $props();

	const backgroundColorId = $derived(camelCase(prefix + "BackgroundColor"));
	const textColorId = $derived(camelCase(prefix + "TextColor"));
</script>

<div class="flex flex-col justify-between gap-2 border-l-[5px] border-l-gray-300 pl-6">
	<div class="flex flex-row gap-2">
		<div class="flex w-full flex-col gap-2">
			<Label for={backgroundColorId} class="font-medium">Background color</Label>
			<ColorInputV2 id={backgroundColorId} allowTransparent resetColor={defaults[backgroundColorId] as string} display="inline" value={(values[backgroundColorId] as string) ?? defaults[backgroundColorId]} showBrandKit={false} oninput={value => onInput?.(backgroundColorId, value)} onchange={value => onChange?.(backgroundColorId, value)} />
		</div>
		<div class="flex w-full flex-col gap-2">
			<Label for={textColorId} class="font-medium">Primary text color</Label>
			<ColorInputV2 id={textColorId} resetColor={defaults[textColorId] as string} display="inline" value={(values[textColorId] as string) ?? defaults[textColorId]} showBrandKit={false} oninput={value => onInput?.(textColorId, value)} onchange={value => onChange?.(textColorId, value)} />
		</div>
	</div>
</div>
